import React, { useRef, useState } from "react";
import { isEmpty, map } from "lodash";
import RadioButtonField from "@/components/RadioButtonField";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import NoDataImg from "@/assets/images/svg/no_data_found.svg";
import youtube from "@/assets/images/webp/video-thumb.webp";
import { Link } from "react-router-dom";

const ImageVideo = (props) => {

  const { profileDetail, cImages, cVideos } = props;

  const options = {
    loop: true,
    margin: 24,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 70000,
    autoplayHoverPause: true,
    // navText: ["<i class='sprite'></i>", "<i class='sprite'></i>"],
    //navText: ["<< ", ">>"],
    //navContainer: ".custom-nav-",
    video: false,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 2 },
      1280: { items: 3 },
      1440: { items: 3 },
    },
  };

  const mediaRef = useRef(null);
  const videoRef = useRef(null);
  const allMediaRef = useRef(null);

  const [mediaType, setMediaType] = useState("IMAGE");


  const extractYouTubeID = (url) => {
    // const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(youtubeRegex);
    return match ? match[1] : null;
  }

  const handleMediaTypeChange = (e, type) => {
    setMediaType(type);
  }

  const goToNextImg = () => {
    mediaRef.current.next();
  };

  const goToPrevImg = () => {
    mediaRef.current.prev();
  };

  const goToNextVideo = () => {
    videoRef.current.next();
  };

  const goToPrevVideo = () => {
    videoRef.current.prev();
  };

  const goToPrevAll = () => {
    allMediaRef.current?.prev();
  };

  const goToNextAll = () => {
    allMediaRef.current?.next();
  };

  const getCombinedMedia = (cImages, cVideos) => {
    const imageItems = map(cImages, (img, idx) => ({
      type: 'IMAGE',
      data: img,
      id: `img_${idx}`
    }));

    const videoItems = map(cVideos, (vid, idx) => ({
      type: 'VIDEO',
      data: vid,
      id: `vid_${idx}`
    }));

    const combined = [...imageItems, ...videoItems];
    // // random
    // for (let i = combined.length - 1; i > 0; i--) {
    //   const j = Math.floor(Math.random() * (i + 1));
    //   [combined[i], combined[j]] = [combined[j], combined[i]];
    // }
    return combined;
  };

  return (
    <>
      {
        profileDetail && (!isEmpty(cImages) || !isEmpty(cVideos)) &&
        <div className="bg-white section-box logistic-company-images-wrap">
          <div className="company-Services-labal d-flex align-items-center">
            <h2 className="head">
              <span><i className="images"></i> Images/Videos</span>
            </h2>
            <div className="d-flex">
              <div className="r-buttn">
                <label>
                  <RadioButtonField
                    onChange={(e) => handleMediaTypeChange(e, "ALL")}
                    checked={mediaType === "ALL"}
                  /> All
                </label>
              </div>
              <div className="r-buttn">
                <label>
                  <RadioButtonField
                    onChange={(e) => handleMediaTypeChange(e, "IMAGE")}
                    checked={mediaType === "IMAGE"}
                  /> Images
                </label>
              </div>
              <div className="r-buttn">
                <label>
                  <RadioButtonField
                    onChange={(e) => handleMediaTypeChange(e, "VIDEO")}
                    checked={mediaType === "VIDEO"}
                  /> Video
                </label>
              </div>
            </div>
          </div>

          {/** Company Images - START */}
          {
            // Carosel
            mediaType === "IMAGE" && cImages?.length > 3 && (
              <div className="mt-2 position-relative crousel-wrape">
                <OwlCarousel className="owl-theme" {...options} ref={mediaRef} key={cImages?.length}>
                  {map(cImages, (val, midx) => (
                    <div className="t-item" key={`img_${midx}`}>
                      <img src={val.src} alt={`img_${midx}`} />
                    </div>
                  ))}
                </OwlCarousel>

                {cImages?.length > 3 && (
                  <div className="nav-ctrl">
                    <button type="button" className="btn prev" onClick={goToPrevImg}>
                      <i className="sprite"></i>
                    </button>
                    <button type="button" className="btn next" onClick={goToNextImg}>
                      <i className="sprite"></i>
                    </button>
                  </div>
                )}
              </div>
            )
          }

          {
            mediaType === "IMAGE" && cImages?.length <= 3 && (
              <div className="mt-2 position-relative crousel-wrape">
                {map(cImages, (val, midx) => (
                  <div className="t-item" key={`img_${midx}`}>
                    <img src={val.src} alt={`img_${midx}`} />
                  </div>
                ))}
              </div>
            )
          }

          {
            mediaType === "IMAGE" && cImages?.length === 0 && (
              <div className="mt-2 position-relative crousel-wrape">
                <img src={NoDataImg} alt="Images not found" className="no-img" />
              </div>
            )
          }
          {/** Company Images - END */}

          {/** Company Videos - START */}
          {
            // Carosel
            mediaType === "VIDEO" && cVideos?.length > 3 && (
              <div className="mt-2 position-relative crousel-wrape">
                <OwlCarousel className="owl-theme" {...options} ref={videoRef} key={cVideos?.length}>
                  {map(cVideos, (val, midx) => {
                    let embedURL = '';
                    if (!isEmpty(val.detail)) {
                      let v = val.detail;
                      if (v.includes('youtube.com') || v.includes('youtu.be')) {
                        const youtubeID = extractYouTubeID(v);
                        if (youtubeID) {
                          embedURL = `https://www.youtube.com/embed/${youtubeID}`;
                        }
                      }

                      if (!isEmpty(embedURL)) {
                        return (
                          <div className="t-item vdo" key={`vid_${midx}`}>
                            <div className="detail--">
                              <div className="item-video">
                                <iframe
                                  src={embedURL}
                                  title="YouTube video"
                                  frameBorder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  style={{ width: '100%', height: '400px' }}
                                ></iframe>
                              </div>
                            </div>
                          </div>
                        );
                      } else {
                        return (< Link to={val.detail} href={val.detail} target="_blank" >
                          <img src={youtube} alt="video" />
                        </Link>)
                      }
                    }
                    return null;
                  })}
                </OwlCarousel>

                {cVideos?.length > 3 && (
                  <div className="nav-ctrl">
                    <button type="button" className="btn prev" onClick={goToPrevVideo}>
                      <i className="sprite"></i>
                    </button>
                    <button type="button" className="btn next" onClick={goToNextVideo}>
                      <i className="sprite"></i>
                    </button>
                  </div>
                )}
              </div>
            )
          }

          {
            mediaType === "VIDEO" && cVideos?.length <= 3 && (
              <div className="mt-2 position-relative crousel-wrape">
                {map(cVideos, (val, midx) => {
                  let embedURL = '';
                  if (!isEmpty(val.detail)) {
                    let v = val.detail;
                    if (v.includes('youtube.com') || v.includes('youtu.be')) {
                      const youtubeID = extractYouTubeID(v);
                      if (youtubeID) {
                        embedURL = `https://www.youtube.com/embed/${youtubeID}`;
                      }
                    }

                    if (!isEmpty(embedURL)) {
                      return (
                        <div className="t-item vdo" key={`vid_${midx}`}>
                          <div className="detail--">
                            <div className="item-video">
                              <iframe
                                src={embedURL}
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                style={{ width: '100%', height: '400px' }}
                              ></iframe>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (<div className="t-item">< Link to={val.detail} href={val.detail} target="_blank" >
                        <img src={youtube} alt="video" />
                      </Link></div>)
                    }
                  }
                  return null;
                })}

              </div>
            )
          }

          {
            mediaType === "VIDEO" && cVideos?.length === 0 && (
              <div className="mt-2 position-relative crousel-wrape">
                <img src={NoDataImg} alt="Images not found" className="no-img" />
              </div>
            )

          }
          {/** Company Videos - END */}

          {/** Combined Media (ALL) - START */}
          {
            mediaType === "ALL" && (cImages?.length > 0 || cVideos?.length > 0) && (() => {
              const combinedMedia = getCombinedMedia(cImages, cVideos);

              return (
                <div className="mt-2 position-relative crousel-wrape">
                  {combinedMedia.length > 3 && <OwlCarousel className="owl-theme" {...options} ref={allMediaRef} key={combinedMedia.length}>
                    {map(combinedMedia, (item, midx) => {
                      if (item.type === 'IMAGE') {
                        return (
                          <div className="t-item" key={item.id}>
                            <img src={item.data.src} alt={item.id} />
                          </div>
                        );
                      } else if (item.type === 'VIDEO') {
                        let embedURL = '';
                        if (!isEmpty(item.data.detail)) {
                          let v = item.data.detail;
                          if (v.includes('youtube.com') || v.includes('youtu.be')) {
                            const youtubeID = extractYouTubeID(v);
                            if (youtubeID) {
                              embedURL = `https://www.youtube.com/embed/${youtubeID}`;
                            }
                          }

                          if (!isEmpty(embedURL)) {
                            return (
                              <div className="t-item vdo" key={item.id}>
                                <div className="detail--">
                                  <div className="item-video">
                                    <iframe
                                      src={embedURL}
                                      title="YouTube video"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                      style={{ width: '100%', height: '400px' }}
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                            );
                          } else {
                            return (<div className="t-item"><Link to={item.data.detail} href={item.data.detail} target="_blank" >
                              <img src={youtube} alt="video" />
                            </Link></div>)
                          }
                        }
                      }
                      return null;
                    })}
                  </OwlCarousel>
                  }

                  {combinedMedia.length > 3 && (
                    <div className="nav-ctrl">
                      <button type="button" className="btn prev" onClick={goToPrevAll}>
                        <i className="sprite"></i>
                      </button>
                      <button type="button" className="btn next" onClick={goToNextAll}>
                        <i className="sprite"></i>
                      </button>
                    </div>
                  )}

                  {
                    combinedMedia.length <= 3 && map(combinedMedia, (item, midx) => {
                      if (item.type === 'IMAGE') {
                        return (
                          <div className="t-item" key={item.id}>
                            <img src={item.data.src} alt={item.id} />
                          </div>
                        );
                      } else if (item.type === 'VIDEO') {
                        let embedURL = '';
                        if (!isEmpty(item.data.detail)) {
                          let v = item.data.detail;
                          if (v.includes('youtube.com') || v.includes('youtu.be')) {
                            const youtubeID = extractYouTubeID(v);
                            if (youtubeID) {
                              embedURL = `https://www.youtube.com/embed/${youtubeID}`;
                            }
                          }

                          if (!isEmpty(embedURL)) {
                            return (
                              <div className="t-item vdo" key={item.id}>
                                <div className="detail--">
                                  <div className="item-video">
                                    <iframe
                                      src={embedURL}
                                      title="YouTube video"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                      style={{ width: '100%', height: '400px' }}
                                    ></iframe>
                                  </div>
                                </div>
                              </div>
                            );
                          } else {
                            return (<div className="t-item"><Link to={item.data.detail} href={item.data.detail} target="_blank" >
                              <img src={youtube} alt="video" />
                            </Link></div>)
                          }
                        }
                      }
                      return null;
                    })
                  }
                </div>
              );
            })()
          }
          {/** Combined Media (ALL) - END */}
        </div >
      }
    </>
  )

}

export default ImageVideo;